import { BodyText, Button, Flex, Modal, Stack } from "@knowtex-ai/components";
import type { ReactElement } from "react";

export interface RecordingErrorModalProps {
  open: boolean;
  onRefresh: () => void;
  onContactSupport: () => void;
}

export default function RecordingErrorModal({
  open,
  onRefresh,
  onContactSupport,
}: RecordingErrorModalProps): ReactElement {
  return (
    <Modal
      open={open}
      title="Recording Error Detected - Empty Audio File"
      size="small"
      showCloseButton={false}
      closeOnEscape={false}
      closeOnPressOutside={false}
    >
      <Stack gap={20}>
        <BodyText>
          We detected an issue with your recording that resulted in no audio being captured. Please
          click &apos;Refresh&apos; below to reset the recorder and start a new session. If this
          issue persists, please contact support.
        </BodyText>
        <Flex justifyContent="flex-end" gap={12}>
          <Button
            type="button"
            variant="secondary"
            aria-label="Refresh recorder"
            onClick={onRefresh}
          >
            Refresh
          </Button>
          <Button type="button" variant="primary-alt" onClick={onContactSupport}>
            Contact Support
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
}
